import region from "./Region";
import { srcList, srcProvince, srcCity, srcArea } from "./formatted";
import { loadTown } from "./helper";

const Plugin = {
  install(Vue, options = {}) {
    if (Object.keys(options).length) {
      if (typeof options.i18n === "string")
        region.props.i18n.default = options.i18n;
      if (typeof options.blank === "boolean")
        region.props.blank.default = options.blank;
      if (typeof options.town === "boolean")
        region.props.town.default = options.town;
      if (typeof options.search === "boolean")
        region.props.search.default = options.search;
    }

    /*
    region.extends = {
      props: {
        abc: {
          type: String,
          default: 'abc'
        }
      }
    }
    console.log(region)
    */

    Vue.component(region.name, region);
  }
};

export default Plugin;

export { srcList, srcProvince, srcCity, srcArea, loadTown };



// WEBPACK FOOTER //
// ./src/index.js